/**
 * External dependencies
 */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Box, Text } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import Section from "components/section";
import { requestLastRanOperation } from "state/import-operation/actions";
import { getLastImportTime } from "state/import-operation/selectors";

/**
 * Style dependencies
 */
import "./styles.scss";

const LastImported = (props) => {
  useEffect(() => {
    checkOperation();
    let _intervalID = setInterval(async () => {
      await checkOperation();
    }, 10000);
    return () => {
      clearTimeout(_intervalID);
    };
  }, []);

  const checkOperation = async () => {
    props.requestLastRanOperation();
  };

  return (
    <Section>
      <Box display="flex" alignItems="center" justifyContent="spaceBetween">
        <Box>
          <Text size="xsmall" weight="medium">
            Data last imported
          </Text>
        </Box>
        <Text size="small">{props.lastImported || "-"}</Text>
      </Box>
    </Section>
  );
};

export default connect(
  (state) => ({
    lastImported: getLastImportTime(state),
  }),
  { requestLastRanOperation }
)(LastImported);
